// removed by extract-text-webpack-plugin
module.exports = {"stat_row":"src-components-StatBar----StatBar-module---stat_row---6NdVv","stat":"src-components-StatBar----StatBar-module---stat---1cfN8","description":"src-components-StatBar----StatBar-module---description---1Rjkp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/StatBar/StatBar.module.scss
// module id = 803
// module chunks = 93803410282108